import { onPageLoad } from "@/lib/on_page_load";
import "@/lib/_jquery";
import "trumbowyg/dist/ui/trumbowyg.min.css";
import "trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css";
// The table apparently broke something?
// import "trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css";
import "trumbowyg/dist/trumbowyg.min";
import "trumbowyg/dist/langs/da";
import "trumbowyg/dist/langs/de";
import "trumbowyg/dist/langs/es";
import "trumbowyg/dist/langs/fr";
import svgIcons from "trumbowyg/dist/ui/icons.svg";

const wysiwygConfig = {
  btns: [
    ["viewHTML"],
    ["undo", "redo"], // Only supported in Blink browsers
    ["formatting"],
    ["strong", "em", "del"],
    ["foreColor", "backColor"],
    ["superscript", "subscript"],
    ["link"],
    ["insertImage"],
    ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
    ["unorderedList", "orderedList"],
    ["horizontalRule"],
    // ["table"],
    ["removeformat"],
    ["fullscreen"],
  ],
  defaultLinkTarget: "_blank",
  tagClasses: {
    // img: "img-fluid", // Does not work for some reason, see wysiwyg_sanitize.rb for a workaround
    table: "table",
  },
  removeformatPasted: true,
  tagsToRemove: ["script", "style", "link"],
  autogrow: true,
  semantic: {"del": "s"},
  svgPath: svgIcons,
};

interface NodeWithTrumbowyg {
  trumbowyg?: any
}

onPageLoad(() => {
  $(".wysiwyg").each((_index, node) => {
    if (node.dataset.wysiwygInitialized) return;
    node.dataset.wysiwygInitialized = "true";
    // If the field has been indirectly disabled, make it explicit here so Trumbowyg can detect it.
    if (node.matches(":disabled")) (node as HTMLInputElement).disabled = true;
    ($(node) as NodeWithTrumbowyg).trumbowyg({
      ...wysiwygConfig,
      lang: node.lang || "en",
    });

    // Add id from the original textarea, plus a suffix, to the editor
    (node.previousSibling as HTMLElement).setAttribute("id", `${node.getAttribute("id")}_editor`);

    // Add the is-invalid class to show that the element contains an error
    if ($(node).hasClass("is-invalid")) {
      $(node.parentNode).addClass("is-invalid border-danger");
    }
  });
});

export default wysiwygConfig;
